const mapElements = document.querySelectorAll('.map-init');

if (mapElements.length > 0) {
  const mapPinsElements = document.querySelectorAll('.map-pin');

  const initialize = (el, mapLat, mapLng, mapZoom) => {
    const parent = el.closest('.map');

    const mapOptions = {
      zoomControl: false,
      zoom: Number(mapZoom),
      center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
      mapTypeControl: false,
      fullscreenControl: false,
      disableDefaultUI: true,
      copyrightControl: false,
      streetViewControl: false,
      scaleControl: false,
      styles: [
        {
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#dcd4c5',
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#ecece4',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'administrative.neighborhood',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'landscape.natural',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#d6c3ad',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#91c3d5',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    };

    const togglePopupContainer = (toggle) => {
      parent.querySelector('.map-items').classList.toggle('hide', toggle);
    };

    const map = new google.maps.Map(el, mapOptions);

    Array.prototype.forEach.call(mapPinsElements, (elm) => {
      const pinLat = elm.getAttribute('data-markerlat');
      const pinLng = elm.getAttribute('data-markerlng');
      const markerName = elm.getAttribute('data-tag');
      const mapPinIcon = elm.getAttribute('data-marker');
      const infoCard = parent.querySelector(`.map-item.${markerName}`);

      // eslint-disable-next-line no-unused-vars
      const marker = new google.maps.Marker({
        // eslint-disable-next-line object-shorthand
        map: map,
        position: new google.maps.LatLng(pinLat, pinLng),
        icon: mapPinIcon,
      });

      marker.addListener('click', () => {
        togglePopupContainer(false);
        if (!infoCard.classList.contains('is-active')) {
          parent.querySelectorAll('.map-item').forEach((item) => {
            item.classList.remove('is-active');
          });
          infoCard.classList.add('is-active');
        }
      });
    });

    parent.querySelector('.plus').addEventListener('click', () => {
      map.setZoom(map.getZoom() + 1);
    });

    parent.querySelector('.minus').addEventListener('click', () => {
      map.setZoom(map.getZoom() - 1);
    });

    parent.querySelector('.eu').addEventListener('click', (ev) => {
      map.setZoom(5);
      map.setCenter(new google.maps.LatLng(mapLat, mapLng));
      togglePopupContainer(true);
      parent.querySelector('.country').classList.remove('is-active');
      ev.target.classList.add('is-active');
    });

    parent.querySelector('.country').addEventListener('click', (ev) => {
      map.setZoom(Number(mapZoom));
      map.setCenter(new google.maps.LatLng(mapLat, mapLng));
      togglePopupContainer(false);
      parent.querySelector('.eu').classList.remove('is-active');
      ev.target.classList.add('is-active');
    });
  };

  window.addEventListener('load', () => {
    mapElements.forEach((el) => {
      const mapLat = el.getAttribute('data-lat') || '46,1738952';
      const mapLng = el.getAttribute('data-lng') || '14,3302704';
      const mapZoom = el.getAttribute('data-zoom') || '9';

      // eslint-disable-next-line no-unused-vars
      initialize(el, mapLat, mapLng, mapZoom);
    });

    attachEvent('.map-item__close', 'click', (ev) => {
      ev.target.closest('.map-item').classList.remove('is-active');
    });
  });
}
